// extracted by mini-css-extract-plugin
export default {"tagContainer":"TDWfv1HsWa70UchmT1Ig","thumb":"AudqCRkaGXAZW8nvf1Tt"};